var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n"], ["\n  display: inline-block;\n  position: relative;\n"
    /**
     * Menu is a [render props](https://reactjs.org/docs/render-props.html) component that exposes
     * a local modal-like behaviour. It provides and `isOpen` property and `toggle` and `close` methods
     * to the child function. This is primarily used with Popover.
     */
])));
/**
 * Menu is a [render props](https://reactjs.org/docs/render-props.html) component that exposes
 * a local modal-like behaviour. It provides and `isOpen` property and `toggle` and `close` methods
 * to the child function. This is primarily used with Popover.
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = function (e) {
            if (_this.wrapRef.current === null)
                return;
            if (!_this.wrapRef.current.contains(e.target) && _this.state.isOpen) {
                if (_this.props.onMenuOffClickClose !== undefined) {
                    _this.props.onMenuOffClickClose();
                }
                _this.close();
            }
        };
        _this.toggle = function () {
            _this.setState(function (prevProps) { return ({
                isOpen: !prevProps.isOpen
            }); });
        };
        _this.close = function () {
            _this.setState({ isOpen: false });
        };
        _this.state = { isOpen: false };
        _this.wrapRef = React.createRef();
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        var _a = this.props.noOffClickClose, noOffClickClose = _a === void 0 ? false : _a;
        if (!noOffClickClose) {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    };
    Menu.prototype.componentWillUnmount = function () {
        var _a = this.props.noOffClickClose, noOffClickClose = _a === void 0 ? false : _a;
        if (!noOffClickClose) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    };
    Menu.prototype.render = function () {
        return (React.createElement(Wrap, { ref: this.wrapRef }, this.props.children({
            isOpen: this.state.isOpen,
            toggle: this.toggle,
            close: this.close
        })));
    };
    Menu.defaultProps = {
        noOffClickClose: false
    };
    return Menu;
}(React.Component));
export { Menu };
var templateObject_1;
//# sourceMappingURL=Menu.js.map